import { Link } from "react-router-dom";
import {
  FaCheckCircle,
  FaDollarSign,
  FaClock,
  FaArrowRight,
} from "react-icons/fa";
import CurrencyDisplay from "../Currency/CurrencyDisplay";

export const PlanCard = ({ isAdmin, plan }) => {
  const isPro = plan.planName === "PLAN 1";

  return (
    <div
      className={`
        relative font-body flex flex-col bg-white rounded-2xl overflow-hidden transition-all duration-300
        ${
          isPro
            ? "border-2 border-primary shadow-xl scale-105 z-10"
            : "border  shadow-sm hover:shadow-lg"
        }
      `}
    >
      {/* Optional: Recommended Badge for Pro plans */}
      {isPro && (
        <div className="bg-primary text-white text-xs font-bold uppercase tracking-wider text-center py-1">
          Most Popular
        </div>
      )}

      <div className="p-6 flex-grow">
        {/* Header Section */}
        <div className="text-center mb-6">
          <h3 className="text-lg font-bold text-gray-500 uppercase tracking-wide">
            {isPro ? "Pro+" : plan.planName}
          </h3>
          <div className="mt-2 flex items-baseline justify-center gap-1 text-textGray">
            <span className="text-4xl md:text-5xl font-bold text-primary tracking-tight">
              {Number(plan.profitProduction) * Number(plan.duration)}%
            </span>
            <span className="text-sm font-medium text-gray-400">ROI</span>
          </div>
          <p className="mt-2 text-sm text-gray-400 font-light px-4">
            {plan.description}
          </p>
        </div>

        {/* Divider */}
        <div className="h-px bg-gray-100 w-full mb-6"></div>

        {/* Features List */}
        <div className="space-y-4">
          <FeatureRow
            icon={<FaDollarSign />}
            label="Range"
            value={
              <>
                <CurrencyDisplay
                  usdAmount={plan.minAmount}
                  className="inline"
                  showCurrency={false}
                />
                {" - "}
                <CurrencyDisplay
                  usdAmount={plan.maxAmount}
                  className="inline"
                />
              </>
            }
          />
          <FeatureRow
            icon={<FaClock />}
            label="Duration"
            value={`${plan.duration} Days`}
          />
          <FeatureRow
            icon={<FaCheckCircle />}
            label="Principal Return"
            value="Included"
            highlight
          />
          <FeatureRow
            icon={<FaCheckCircle />}
            label="Payouts"
            value="Instant"
          />
        </div>
      </div>

      {/* Footer / CTA Action */}
      <div className="p-6 pt-0 mt-auto ">
        {isAdmin ? (
          <button className="w-full py-3 rounded-xl border-2 border-primary text-primary font-semibold hover:bg-primary hover:text-white transition-colors duration-300">
            Edit Plan
          </button>
        ) : (
          <Link to="/dashboard/proceed">
            <button className="w-full py-3 rounded-lg bg-gradient-to-r from-primary to-blue-500  shadow-sm text-white font-semibold hover:bg-primaryDark hover:scale-[1.02] active:scale-95 transition-all duration-300 flex items-center justify-center gap-2">
              Start Investing <FaArrowRight className="text-sm" />
            </button>
          </Link>
        )}
      </div>
    </div>
  );
};

// Helper component to clean up the main code
const FeatureRow = ({ icon, label, value, highlight = false }) => (
  <div className="flex items-center justify-between text-sm">
    <div className="flex items-center gap-3 text-gray-500">
      <div className="p-1.5 rounded-full bg-primary/10 text-primary">
        {icon}
      </div>
      <span>{label}</span>
    </div>
    <span
      className={`font-semibold ${
        highlight ? "text-primary" : "text-gray-700"
      }`}
    >
      {value}
    </span>
  </div>
);
